import _ from 'lodash'

function deepDiff (a, b, out) {
  _.each(a, function (v, k) {
    // already checked this or equal...
    // if (out.hasOwnProperty(k)) return;
    let isSameType = typeof a === typeof b

    if (isSameType && b[k] === v) return

    if (isSameType && _.isArray(v)) {
      // todo need to improve array types
      if (JSON.stringify(b[k]) !== JSON.stringify(v)) {
        out[k] = v
      }
    } else if (isSameType && _.isObject(v)) {
      out[k] = _.diffDeep(v, b[k])
    } else {
      // but what if it returns an empty object? still attach?
      out[k] = v
    }
  })
}

_.mixin({
  diffDeep: function (a, b) {
    let result = {}
    deepDiff(b, a, result)
    deepDiff(a, b, result)
    return _.removeEmptyObjects(result)
  }
})

_.mixin({
  removeEmptyObjects (obj) {
    return _(obj)
      .pickBy(_.isObject) // pick objects only
      .mapValues(_.removeEmptyObjects) // call only for object values
      .omitBy(_.isEmpty) // remove all empty objects
      .assign(_.omitBy(obj, _.isPlainObject)) // assign back primitive values
      .value()
  }
})

// use lodash instead underscore
if (window) {
  window._ = window.lodash = _
}

export default _



// WEBPACK FOOTER //
// ./src/env/lodash.js